import React from 'react';
import { useWootricLoadScript } from './hooks/useWootricLoadScript';
import { UserRole } from '../../../types/common';
import { useWootricDebug } from './hooks/useWootricDebug';
import { useWootric } from './hooks/useWootric';
import { Wootric as IWootric } from './types';

export function Wootric({
  accountToken,
  productName,
  role,
  email,
  createdAt,
  debug = false
}: IWootric.Props) {
  // Add Wootric component only if user is a employee
  const isEnabled = !!(role && role === UserRole.Broker);
  const { scriptReady } = useWootricLoadScript({
    src: 'https://cdn.wootric.com/wootric-sdk.js',
    isEnabled
  });
  useWootricDebug({ debug });
  useWootric({
    isEnabled,
    scriptReady,
    accountToken,
    productName,
    email,
    createdAt
  });

  return null;
}
